export class FilterWithInitialLoadingStyle extends HTMLElement {
	/**
	 * Call at end of specific render method.
	 */
	removeInitialLoading() {
		if (this.classList.contains("filter-box__section--initial-loading")) {
			setTimeout(
				() => this.classList.remove("filter-box__section--initial-loading"),
				500,
			);
		}
	}
}
